import ProfileApi from '@/features/Profile/services';
import { CreateProfileDto, CreateProfileResponseDto, ProfileDto } from '@/types/webapi';

const profileApi = new ProfileApi();
export const getProfile = async (): Promise<ProfileDto> => {
    return await profileApi.getProfile();
};

export const registerProfile = async (createProfile: CreateProfileDto): Promise<CreateProfileResponseDto> => {
    return await profileApi.registerProfile(createProfile);
};
